import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default function Percorso({ 
    title, 
    subtitle, 
    tags, 
    img1, 
    alt1,
    img2, 
    alt2,
    img3, 
    alt3
}) {
    const images = [img1, img2, img3];

    return (
        <section className="min-h-screen text-white flex flex-col overflow-hidden py-10">
            <div className="text-center shrink-0 px-6">
                <h2 className="text-4xl md:text-5xl font-semibold text-mcare mb-8">{title}</h2>
                <p className=" text-lg  w-full md:w-1/2 mx-auto">{subtitle}</p>
            </div>
            <div className="flex justify-center text-2xl font-bold mt-10 shrink-0 px-6">
                <p>
                    {tags}
                </p>

            </div>

            <div className="mt-10 px-4 md:px-20 flex-1 min-h-0">
                {/* Desktop grid */}
                <div className="hidden md:grid grid-cols-3 gap-10 h-full">
                    {images.map((img, index) => (
                        <div key={index} className="w-full h-full overflow-hidden rounded-md">
                            <img src={img} alt={index === 0 ? alt1 : index === 1 ? alt2 : alt3} className="w-full h-full object-cover" />
                        </div>
                    ))}
                </div>

                {/* Mobile slider */}
                <div className="block md:hidden h-full">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        pagination={{
                            dynamicBullets: true,
                            clickable: true,
                        }}
                        modules={[Autoplay, Pagination]}
                        className="w-full h-full"
                    >
                        {images.map((img, index) => (
                            <SwiperSlide key={index} className="h-full">
                                <div className="w-full h-full overflow-hidden rounded-md">
                                    <img src={img} alt={index === 0 ? alt1 : index === 1 ? alt2 : alt3} className="w-full h-full object-cover" />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}